import makeStyles from '@material-ui/core/styles/makeStyles';
import React from 'react';
import { Filter, useTranslate } from 'react-admin';

import TextInputEx from "../../../components/_extensions/react-admin/input/TextInputEx";
import { ToggleDatesEnum, ToggleDatesFilter } from '../../../components/filters/ToggleDatesFilter';
import { ToggleTitleInput } from '../../../components/filters/ToggleInputs';
import { TERMINAL_DEFAULT_VALUE } from '../../../components/filters/ToggleTerminalsFilter';
import { DateInput } from '../../../components/inputs/DateTimeInput';
import { filterColors } from '../../../utils/constants';
import { envSettings } from 'core/EnvSettings';

export const filterDefaultValues = {
	"named_eta_etd_datetime": [ToggleDatesEnum.TODAY],
	"terminal_id": [TERMINAL_DEFAULT_VALUE],
};


const useStyles = makeStyles(t => ({	
	filterSearch: {
		backgroundColor: filterColors.search
	},
}));

const REACT_APP_4_HOURS_AHEAD_FILTER__HIDDEN = envSettings.REACT_APP_4_HOURS_AHEAD_FILTER__HIDDEN;

export const EntitiesFilter = ({isSearchMode, ...props}) => {
	const translate = useTranslate();
	const classes = useStyles();
	return(
	<Filter {...props}>
		{!isSearchMode && [
		<ToggleDatesFilter 
			source="named_eta_etd_datetime" 
			hiddenButtons={{[ToggleDatesEnum.FOUR_HOURS_AHEAD]: REACT_APP_4_HOURS_AHEAD_FILTER__HIDDEN}}
			defaultValue={null} 
			alwaysOn 
		/>,

		<TextInputEx 
			source="id" 
			key="id" 
		/>,
		
		<TextInputEx 
			source="work_time" 
			key="work_time" 
		/>,

		<TextInputEx 
			source="rank" 
			key="rank" 
		/>,

		<DateInput 
			source="eta_date" 
			margin="dense" 
			resettable 
			key="eta_date"
		/>,

		<DateInput 
			source="etd_date" 
			margin="dense" 
			resettable 
			key="etd_date"
		/>]}

		<ToggleTitleInput source="is_search" value={true} key={"is_search"} 
		label0={translate("osfc.filters.toggles.search")} label1={translate("osfc.filters.toggles.back_to_entities")} 
		alwaysOn className={classes.filterSearch}/>
		
		{isSearchMode && <TextInputEx label={translate("osfc.filters.toggles.docs_search")} source="doc_search_text" alwaysOn/>}
	</Filter>
)};
